import {useState, type CSSProperties} from 'react';
import {useTheme} from '@components/theme/useTheme';
import {replaceAvatarUrlWithTheme} from '@utils/user';
import type {AvatarSource} from '@types';
import '../../styles/user-identity.scss';

export type AvatarUser = {
    avatar?: {sources?: AvatarSource[]} | null;
};

export const UserAvatar = ({
    user,
    size = 30,
    className = '',
    style,
}: {
    user?: AvatarUser | null;
    size?: number;
    className?: string;
    style?: CSSProperties;
}) => {
    const theme = useTheme();
    const [failedUrl, setFailedUrl] = useState<string | null>(null);
    const fallback = replaceAvatarUrlWithTheme(
        '/build/images/avatar_placeholder64.jpeg',
        theme
    );
    const sources = user?.avatar?.sources;
    const url = replaceAvatarUrlWithTheme(
        sources?.find(source => source.size === 64)?.url ||
            sources?.find(source => source.url)?.url ||
            fallback,
        theme
    );

    return (
        <img
            className={`user-avatar ${className}`.trim()}
            src={failedUrl === url ? fallback : url}
            onError={() => setFailedUrl(url)}
            alt=""
            width={size}
            height={size}
            style={
                {'--user-avatar-size': `${size}px`, ...style} as CSSProperties
            }
        />
    );
};
